import { useMemo, useState } from 'react';
import { BaseRecord } from '@refinedev/core';
import { DataTableColumn, DataTableSortStatus } from 'mantine-datatable';

export default function useSortableData<T extends BaseRecord>(
  data: T[],
  columns: DataTableColumn<T>[],
) {
  const sortableColumn = columns.find(c => c.sortable);
  const [sortStatus, setSortStatus] = useState<DataTableSortStatus<T>>({
    columnAccessor: sortableColumn?.accessor ?? '',
    sortKey: sortableColumn?.sortKey ?? '',
    direction: 'asc',
  });

  const sortedData = useMemo(() => {
    if (sortableColumn == null || !sortStatus.sortKey) {
      return data;
    }
    return [...data].sort((a, b) => {
      const aValue = a[sortStatus.sortKey as keyof T];
      const bValue = b[sortStatus.sortKey as keyof T];
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return sortStatus.direction === 'desc'
          ? bValue.localeCompare(aValue)
          : aValue.localeCompare(bValue);
      }
      return 0;
    });
  }, [sortStatus, data]);

  return { sortStatus, setSortStatus, sortedData };
}
